import { Observable } from 'rxjs';

/**
 * Application-provided bridge between the tenant selection and this
 * library. Keeps the library decoupled from app state: provide an
 * implementation for this class in the application root injector.
 */
export abstract class NgrxStoreIdbTenantResolver {
  /**
   * Emits the resolved tenant id. Only the first emission is used —
   * within one page life the tenant store never changes tenant.
   */
  abstract tenantId$(): Observable<string>;

  /**
   * Called when the resolved tenant differs from the tenant the store was
   * bootstrapped with (e.g. a different user logged in on the same tab).
   * The implementation should persist the resolved tenant and reload the
   * page so the whole app bootstraps against the correct tenant store.
   */
  abstract onTenantMismatch(resolvedTenantId: string): void;
}
